import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { track } from '@/shared/analytics/track';
import { APP_PREFIX, LOGIN_ROUTES } from '@/shared/routes/paths';

const useLegacyHitTracking = (from: string, to: string): void => {
  useEffect(() => {
    track('legacy_route_redirect', { from, to });
    if (import.meta.env.DEV) {
      // Surfaces internal code still navigating to an un-prefixed path. Without
      // this the shim silently masks the bug until the shim itself is removed.
      // eslint-disable-next-line no-console
      console.warn(`[routes] legacy path "${from}" redirected to "${to}"`);
    }
  }, [from, to]);
};

// Forwards every pre-/app path to its prefixed equivalent, preserving the query
// string and hash so deep links like /reports?brandId=x survive.
export const LegacyAppRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  const to = `${APP_PREFIX}${pathname}${search}${hash}`;

  useLegacyHitTracking(pathname, to);

  return <Navigate to={to} replace={true} />;
};

// Forwards /auth/* to /login. Preserving `search` is load-bearing: an older
// b2b-api still sends WorkOS failures to `${portal}/auth/login?error=<message>`.
export const LegacyAuthRedirect: React.FC = () => {
  const { pathname, search } = useLocation();
  const to = `${LOGIN_ROUTES.ROOT}${search}`;

  useLegacyHitTracking(pathname, to);

  return <Navigate to={to} replace={true} />;
};
